/** All supported world map styles. */
const MAP_STYLES = ["colored", "satellite"];

/** All supported world map modes. */
const MAP_MODES = ["2D", "3D"];

/**
 * Type guard that checks whether a stored value is a supported map style.
 * @param value - The value to check.
 * @returns True if the value is a valid MapStyle, false otherwise.
 */
export function isMapStyle(value) {
  return value !== null && MAP_STYLES.includes(value);
}

/**
 * Type guard that checks whether a stored value is a supported map mode.
 * @param value - The value to check.
 * @returns True if the value is a valid MapMode, false otherwise.
 */
export function isMapMode(value) {
  return value !== null && MAP_MODES.includes(value);
}